import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  USER_INTERFACE_EQUALIZER_ROTATED,
  Icon,
  Select,
  Button,
} from '@bwoty-web/styleguide';
import * as CruiseListActions from '../../redux/actions/cruiseListActions';
import { filteredCruisePackagesCountSelector } from '../../redux/selectors/cruiseList/filterSelectors';
import './sortPanel.scss';

const SortPanel = (props) => {
  const {
    labels,
    numberOfCruises,
    numberOfFilteredCruises,
    selectedSortOrder,
    sortOptions,
    actions,
    isInspiration,
  } = props;

  const getNumberOfCruisesLabel = () => {
    let numberOfCruisesLabel = '';

    if (numberOfFilteredCruises === numberOfCruises) {
      numberOfCruisesLabel = labels.cruiseCountLabel.replace(
        '{numberOfCruises}',
        numberOfCruises,
      );
    } else {
      numberOfCruisesLabel = labels.filteredCruiseCountLabel
        .replace('{matches}', numberOfFilteredCruises)
        .replace('{total}', numberOfCruises);
    }

    return numberOfCruisesLabel;
  };

  const getMobileFilterButton = () => (
    <Button
      theme="blue"
      className="iw-cruise-list-sort-panel__mobile-filter-button"
      onClick={() => actions.toggleFilterPanel(true)}
    >
      <Icon
        path={USER_INTERFACE_EQUALIZER_ROTATED}
        className="iw-cruise-list-sort-panel__mobile-filter-button-icon"
        sizeMobile="xs"/>
      <span>{labels.filterHeading}</span>
    </Button>
  );

  const getTabletFilterButton = () => (
    <button
      type="button"
      className="iw-cruise-list-sort-panel__tablet-filter-button"
      onClick={() => actions.toggleFilterPanel(true)}
    >
      <Icon
        path={USER_INTERFACE_EQUALIZER_ROTATED}
        className="iw-cruise-list-sort-panel__tablet-filter-button-icon"
        size="xs"/>
      <span className="iw-cruise-list-sort-panel__tablet-filter-button-text">{labels.filterHeading}</span>
    </button>
  );

  return (
    <div className="iw-cruise-list-sort-panel">
      {getMobileFilterButton()}
      <div className="iw-cruise-list-sort-panel__left">
        <div className="iw-cruise-list-sort-panel__hits">{getNumberOfCruisesLabel()}</div>
      </div>
      <div className="iw-cruise-list-sort-panel__right">
        {getTabletFilterButton()}
        {!isInspiration && <Select
          className="iw-cruise-list-sort-panel__sort-control"
          items={sortOptions}
          value={selectedSortOrder}
          onChange={(e) => {
            actions.sortCruiseList(e.target.value);
          }}
        />}
      </div>
    </div>
  );
};

SortPanel.propTypes = {
  labels: PropTypes.shape({
    filterHeading: PropTypes.string.isRequired,
    cruiseCountLabel: PropTypes.string.isRequired,
    filteredCruiseCountLabel: PropTypes.string.isRequired,
  }).isRequired,
  numberOfCruises: PropTypes.number.isRequired,
  numberOfFilteredCruises: PropTypes.number.isRequired,
  selectedSortOrder: PropTypes.string.isRequired,
  sortOptions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  actions: PropTypes.shape({
    sortCruiseList: PropTypes.func.isRequired,
    toggleFilterPanel: PropTypes.func.isRequired,
  }).isRequired,
  isInspiration: PropTypes.bool.isRequired,
};

function mapActions(dispatch) {
  return {
    actions: bindActionCreators({ ...CruiseListActions }, dispatch),
  };
}

function mapStateToProps(state) {
  const newState = state.toJS();
  const { isInspiration } = newState.common.siteSettings;
  const numberOfCruises = newState.cruises.cruises.length;

  return {
    labels: newState.labels,
    numberOfCruises,
    numberOfFilteredCruises: filteredCruisePackagesCountSelector(newState),
    selectedSortOrder: newState.sort.selected,
    sortOptions: newState.sort.sortOptions,
    isInspiration,
  };
}

export default connect(mapStateToProps, mapActions)(SortPanel);